import { render, staticRenderFns } from "./ProfileSetting.vue?vue&type=template&id=47ff8a3b&scoped=true"
import script from "./ProfileSetting.vue?vue&type=script&lang=js"
export * from "./ProfileSetting.vue?vue&type=script&lang=js"
import style0 from "./ProfileSetting.vue?vue&type=style&index=0&id=47ff8a3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ff8a3b",
  null
  
)

export default component.exports